import { OrderListItem } from '@shared/model/order';

export const getOrderInitiator = (orderData?: OrderListItem) => {
    const requestsCount = orderData?.requests?.length;
    const initiatorId = orderData?.initiator?.id;
    const managerId = orderData?.company?.manager?.id;

    if (requestsCount === 1 && initiatorId !== managerId) {
        return {
            title: 'Сотрудник',
            initiator: orderData?.initiator,
            isInitiatorEmployee: true,
        };
    }

    return {
        title: 'Менеджер',
        initiator: orderData?.initiator,
        isInitiatorEmployee: false,
    };
};
